(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kro-fakedrop-included"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('#krosper-fakedrop-{{ section.id }}');
    if (!root) return;

    // Enable safe animations
    if (root.dataset.animate === 'true') { root.classList.add('js-anim'); }

    // Reveal on view
    if ('IntersectionObserver' in window){
      const io = new IntersectionObserver((entries)=>{
        entries.forEach(e=>{
          if (e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      root.classList.add('in-view');
    }

    // Parallax
    const media = root.querySelector('[data-parallax]');
    if (media){
      const onScroll = () => {
        const rect = media.getBoundingClientRect();
        const win = window.innerHeight || document.documentElement.clientHeight;
        const prog = Math.min(1, Math.max(0, 1 - (rect.top / win)));
        const delta = (prog * 12) - 6; // -6px..+6px
        media.style.setProperty('--parallax', `${delta}px`);
        media.classList.add('parallax-on');
      };
      onScroll(); window.addEventListener('scroll', onScroll, { passive:true });
    }

    // Tilt 3D
    const tilt = root.querySelector('[data-tilt]');
    if (tilt){
      let raf;
      const max = 6;
      const figure = tilt.querySelector('.kfd__figure');
      const enter = ()=> tilt.classList.add('tilt-on');
      const leave = ()=>{
        tilt.classList.remove('tilt-on'); tilt.classList.add('tilt-reset');
        figure.style.transform = `rotateX(0deg) rotateY(0deg) scale(1)`;
        window.setTimeout(()=> tilt.classList.remove('tilt-reset'), 360);
      };
      const move = (e)=>{
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(()=>{
          const r = tilt.getBoundingClientRect();
          const x = (e.clientX - r.left)/r.width - .5;
          const y = (e.clientY - r.top)/r.height - .5;
          const rx = (y * -max).toFixed(2);
          const ry = (x *  max).toFixed(2);
          figure.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.02)`;
        });
      };
      tilt.addEventListener('mouseenter', enter);
      tilt.addEventListener('mousemove', move);
      tilt.addEventListener('mouseleave', leave);
      tilt.addEventListener('touchstart', enter, {passive:true});
      tilt.addEventListener('touchmove', (e)=>{ const t = e.touches[0]; if(!t) return; move(t); }, {passive:true});
      tilt.addEventListener('touchend', leave);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kro-infernal-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('#krosper-finalboss-{{ section.id }}');
  if (!root) return;
  if (root.dataset.animate === 'true') root.classList.add('js-anim');

  if ('IntersectionObserver' in window){
    const io = new IntersectionObserver((entries)=>{
      entries.forEach(e=>{ if (e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target); } });
    }, { threshold: .2 });
    io.observe(root);
  } else { root.classList.add('in-view'); }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["krosper-acid-included"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('#krosper-acid-pro-{{ section.id }}');
    if (!root) return;

    // Mark section as animation-enabled (safe: visible by default)
    if (root.dataset.animate === 'true') {
      root.classList.add('js-anim');
    }

    // Reveal
    if ('IntersectionObserver' in window){
      const io = new IntersectionObserver((entries)=>{
        entries.forEach(e=>{
          if (e.isIntersecting){ e.target.classList.add('in-view'); io.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      io.observe(root);
    } else {
      root.classList.add('in-view');
    }

    // Parallax
    const media = root.querySelector('[data-parallax]');
    if (media){
      const onScroll = () => {
        const rect = media.getBoundingClientRect();
        const win = window.innerHeight || document.documentElement.clientHeight;
        const prog = Math.min(1, Math.max(0, 1 - (rect.top / win)));
        const delta = (prog * 12) - 6; // -6px..+6px
        media.style.setProperty('--parallax', `${delta}px`);
        media.classList.add('parallax-on');
      };
      onScroll(); window.addEventListener('scroll', onScroll, { passive:true });
    }

    // Tilt 3D
    const tilt = root.querySelector('[data-tilt]');
    if (tilt){
      let raf;
      const max = 6;
      const figure = tilt.querySelector('.kap__figure');
      const enter = ()=> tilt.classList.add('tilt-on');
      const leave = ()=>{
        tilt.classList.remove('tilt-on'); tilt.classList.add('tilt-reset');
        figure.style.transform = `rotateX(0deg) rotateY(0deg) scale(1)`;
        window.setTimeout(()=> tilt.classList.remove('tilt-reset'), 360);
      };
      const move = (e)=>{
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(()=>{
          const r = tilt.getBoundingClientRect();
          const x = (e.clientX - r.left)/r.width - .5;
          const y = (e.clientY - r.top)/r.height - .5;
          const rx = (y * -max).toFixed(2);
          const ry = (x *  max).toFixed(2);
          figure.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.02)`;
        });
      };
      tilt.addEventListener('mouseenter', enter);
      tilt.addEventListener('mousemove', move);
      tilt.addEventListener('mouseleave', leave);
      tilt.addEventListener('touchstart', enter, {passive:true});
      tilt.addEventListener('touchmove', (e)=>{ const t = e.touches[0]; if(!t) return; move(t); }, {passive:true});
      tilt.addEventListener('touchend', leave);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
